import { render, staticRenderFns } from "./SelectGroupDialog.vue?vue&type=template&id=565da808&"
import script from "./SelectGroupDialog.vue?vue&type=script&lang=js&"
export * from "./SelectGroupDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectGroupDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports